module.exports = __webpack_public_path__ + "img/AppleID.52e1c95.svg";